import { memo, useMemo } from "react";
import { WebChat } from "@rshbintech.ctp/webchat";
import { ChatBubble as ChatBubbleIcon } from "@rshbintech.dboul/icons";
import { getChatFeatureSettings, getCountLabel } from "./utils";
import { apiCallbacks, sseConfig } from "./constants";
import type { Config } from "@rshbintech.ctp/webchat";
import type { ChatProps } from "./types";
import styles from "./styles.scss";

export const Chat = memo(({ clientSettings }: ChatProps) => {
  const config: Config = useMemo(() => {
    const featureSettings = getChatFeatureSettings(clientSettings);

    return { api: apiCallbacks, sse: sseConfig, feature: featureSettings };
  }, [clientSettings]);

  const chat = (
    <WebChat config={config}>
      {({ unreadMessages, handleButtonClick }) => (
        <div
          className={styles["chat-icon-container"]}
          data-rptracker-event="click"
          data-rptracker-category="dboHeader"
          data-rptracker-action="menuChatClick"
          onClick={handleButtonClick}
        >
          {Boolean(unreadMessages) && (
            <div className={styles["unread-messages-marker"]}>
              {getCountLabel(unreadMessages)}
            </div>
          )}
          <ChatBubbleIcon size="medium" />
        </div>
      )}
    </WebChat>
  );

  return config.feature?.chatEnable ? chat : null;
});
